import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const selectCommon = (state: RootState) => state.common;

export const selectLoading = createSelector(selectCommon, (common) => common.loading);
export const selectModalStatus = createSelector(selectCommon, (common) => common.ui.dialog);
export const selectNotificationSnackbar = createSelector(selectCommon, (common) => common.snackbar);
export const selectSidebarOpen = createSelector(selectCommon, (common) => common.sidebar.open);
export const selectModalState = createSelector(selectCommon, (common) => common.ui.dialogState);

export const selectModalStateByName = (name: string) => createSelector(selectModalStatus, (state) => state[name]);
